import PrintableCheckboxfield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoCheckboxField";
import PrintableMemoDropdownField from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoDropdownField";
import PrintableMemoFilefield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoFileField";
import PrintableFixedTableField from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoFixedTableField";
import PrintableMemoFormTextField from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoFormTextField";
import PrintableRadiobuttonfield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoRadioButtonField";
import PrintableMemoSignaturefield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoSignatureField";
import PrintableTablefield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoTableField";
import PrintableTextfield from "pages/Deal/PrintableMemo/components/PrintableDDSection/PrintableMemoTextField";
import PrintableRichtextfield from "pages/Deal/PrintableMemo/components/PrintableMemoRichTextField";

import { IPackageDetailsField } from "entities/Checklist/sdk";
import { FieldType } from "entities/Field/sdk";

interface IPrintableDDSectionWrapper {
  field: IPackageDetailsField;
  isNASection: boolean;
}

const PrintableDDSectionWrapper = ({
  field,
  isNASection,
}: IPrintableDDSectionWrapper) => {
  switch (field.field_type) {
    case FieldType.FORM_TEXT_FIELD:
      return (
        <PrintableMemoFormTextField field={field} isNASection={isNASection} />
      );
    case FieldType.DROPDOWN:
      return (
        <PrintableMemoDropdownField field={field} isNASection={isNASection} />
      );
    case FieldType.CHECKBOX:
      return <PrintableCheckboxfield field={field} isNASection={isNASection} />;
    case FieldType.RADIO_BUTTON:
      return (
        <PrintableRadiobuttonfield field={field} isNASection={isNASection} />
      );
    case FieldType.TEXT_FIELD:
      return <PrintableTextfield field={field} isNASection={isNASection} />;
    case FieldType.RICH_TEXT_FIELD:
      return <PrintableRichtextfield field={field} isNASection={isNASection} />;
    case FieldType.SIGNATURE:
      return (
        <PrintableMemoSignaturefield field={field} isNASection={isNASection} />
      );
    case FieldType.TABLE:
      return <PrintableTablefield field={field} isNASection={isNASection} />;
    case FieldType.FIXED_TABLE:
      return (
        <PrintableFixedTableField field={field} isNASection={isNASection} />
      );
    case FieldType.FILE:
      return <PrintableMemoFilefield field={field} isNASection={isNASection} />;
  }
  return null;
};

export default PrintableDDSectionWrapper;
